import React from 'react';

import { MuiIcon } from 'components/common/Icons/base/MuiIcon/MuiIcon';

import classes from 'components/pages/ScheduleViewsPage/components/ViewConfiguration/components/ViewConfigurationDrawerForm/components/NoRowsConfiguredEmptyState/NoRowsConfiguredEmptyState.module.scss';

interface Props {
    isViewOwner: boolean;
}

export const NoRowsConfiguredEmptyState = ({ isViewOwner }: Props) => {
    return (
        <div className={classes.root} data-testid={'configure-view-rows-empty-state'}>
            <div className={classes.iconRing}>
                <div className={classes.iconInner}>
                    <MuiIcon icon={'view_list'} type={'outlined'} fontSize={'4.8rem'} color={'var(--text-quinary)'} />
                </div>
            </div>
            <h2 className={classes.title}>No rows configured</h2>
            <p className={classes.subtitle}>
                {isViewOwner
                    ? 'Use add new row below to create your first row and choose what appears in the timeline.'
                    : 'This view does not include any rows yet. Only the view owner can add or change rows.'}
            </p>
        </div>
    );
};
